import axios from 'axios';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
import router from '../router';

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response && error.response.status === 401) {
        router.push('/logout');
    }
    return Promise.reject(error);
});
export default {
    getAccessToken() {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    },

    saveAccessToken(accessToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    },

    removeAccessToken() {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        delete axios.defaults.headers.common.Authorization;
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    },

    saveTokens(access, refresh) {
        this.saveAccessToken(access);
        this.saveRefreshToken(refresh);
    },

    removeTokens() {
        this.removeAccessToken();
        this.removeRefreshToken();
    },

    decodeToken(token) {
        try {
            let tokenParts = token.split(".", 3);
            return {
                header: JSON.parse(atob(tokenParts[0])),
                payload: JSON.parse(atob(tokenParts[1]))
            };
        } catch(e) {
            return {};
        }
    },

    isTokenStale(token) {
        if (!token) {
            return true;
        }

        try {
            let expireTime = this.decodeToken(token).payload.exp;
            let nowTime = Math.round(new Date().getTime() / 1000);

            return expireTime - nowTime <= 0;
        } catch (e) {
            return true;
        }
    },

    isAccessTokenStale() {
        return this.isTokenStale(this.getAccessToken());
    },

    isRefreshTokenStale() {
        return this.isTokenStale(this.getRefreshToken());
    }
};
